import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { Scrollbars } from 'react-custom-scrollbars';

import { makeStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import { Typography, Button, Breadcrumbs } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import Checkbox from '@material-ui/core/Checkbox';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import MbInput from 'components/atoms/MbInput';
import Icon from 'components/atoms/Icon';

import LoginFormTemplate from 'pages/templates/LoginFormTemplate';
import MainLogo from 'images/common/logo/logo_white.png';

const useStyles = makeStyles((theme) => ({
  customScroll: {
    position: 'fixed !important',
    '& > div': { backgroundColor: '#3a4652' },
  },
  loginWrap: {
    position: 'relative',
    maxWidth: '100%',
    boxSizing: 'border-box',
    margin: '100px auto 20px',
    border: 0,
    borderRadius: '2px',
  },
  formLogo: {
    width: '40%',
    maxWidth: 170,
    margin: '0 auto 30px',
    textAlign: 'center',
    '& > img': { width: '100%' },
  },
  loginFormWrap: {
    display: 'block',
    width: 'calc(100% - 40px)',
    maxWidth: 500,
    padding: '15px 35px 35px',
    margin: '0 auto',
    boxSizing: 'border-box',
    backgroundColor: '#fff',
    borderTop: '4px solid #85b74e',
    borderRadius: 4,
    fontSize: theme.spacing(2),
    verticalAlign: 'top',
    textAlign: 'left',
  },
  textField: {
    width: '100%',
    '& input': {
      height: 50,
      padding: 0,
      boxSizing: 'border-box',
      verticalAlign: 50,
      '&::-ms-clear': { display: 'none' },
    },
  },
  loginMessage: {
    maxWidth: 355,
    marginTop: theme.spacing(1),
    color: theme.palette.primary.error,
    fontSize: '.8em',
  },
  loginNav: { marginLeft: 'auto', '& a': { cursor: 'pointer' } },
  container: { '& > div:first-child': { marginTop: 30, marginBottom: 30 } },
  avatar: { background: 'none', marginRight: -theme.spacing(1.5) },
  loginOption: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginTop: 10,
  },
  whiteText: { color: '#fff' },
  submitBtn: { display: 'flex', width: '100%', marginTop: theme.spacing(1) },
  smallText: { fontSize: '.9rem', textDecoration: 'none' },
}));

const LoginForm = ({
  form,
  error,
  saveId = false,
  onChange,
  onChangeCheckbox,
  onSubmit,
}) => {
  const tablet = useMediaQuery('(max-width: 768px)');
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Scrollbars
      autoHide
      autoHideTimeout={1000}
      autoHideDuration={200}
      className={classes.customScroll}
    >
      <LoginFormTemplate>
        <div className={classes.loginWrap}>
          <div className={classes.formLogo}>
            <img src={MainLogo} alt="logo" />
          </div>
          <div className={clsx(classes.loginFormWrap, { tablet })}>
            <form
              className={classes.container}
              autoComplete="off"
              onSubmit={onSubmit}
            >
              <MbInput
                id="userId"
                name="userId"
                placeholder={t('아이디')}
                className={classes.textField}
                value={form.userId}
                onChange={onChange('userId')}
                margin="none"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Icon icon={'faUser'} style={{ fontSize: 18 }} />
                    </InputAdornment>
                  ),
                }}
              />
              <MbInput
                id="userPassword"
                name="Password"
                type="password"
                placeholder={t('비밀번호')}
                className={classes.textField}
                value={form.password}
                onChange={onChange('password')}
                autoComplete="current-password"
                margin="none"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Icon icon={'faLockAlt'} style={{ fontSize: 18 }} />
                    </InputAdornment>
                  ),
                }}
              />
              <Typography className={classes.loginMessage} variant="body1">
                {error}
              </Typography>
              <div className={classes.loginOption}>
                <div className={classes.saveId}>
                  <FormControlLabel
                    className={classes.checkboxLeftResize}
                    control={
                      <Checkbox
                        color="primary"
                        checked={saveId}
                        onChange={onChangeCheckbox}
                        value="saveId"
                      />
                    }
                    label={t('아이디 저장')}
                    labelPlacement="end"
                  />
                </div>
                <div className={classes.loginNav}>
                  <Paper elevation={0} className={classes.paper}>
                    <Breadcrumbs maxItems={2} aria-label="breadcrumb">
                      <Link
                        color="inherit"
                        // href="/findPassword"
                        href="/findPassword"
                        className={classes.smallText}
                      >
                        {t('비밀번호 재설정')}
                      </Link>
                      <Link href="/join" className={`${classes.smallText}`}>
                        {t('계정 생성')}
                      </Link>
                    </Breadcrumbs>
                  </Paper>
                </div>
              </div>
              <Button
                type="submit"
                variant="contained"
                size="large"
                color="primary"
                className={`${classes.whiteText} ${classes.submitBtn}`}
              >
                {t('로그인')}
              </Button>
            </form>
          </div>
        </div>
      </LoginFormTemplate>
    </Scrollbars>
  );
};

export default LoginForm;
